export default "__VITE_ASSET__QIFIAHTX__"